<div class="competitions">
  @for (comp of competitionLinks(); track comp.link) {
    <lib-web-competition-link
      class="competition"
      [link]="comp.link"
      [icon]="comp.icon"
      [name]="comp.name"
      [winner]="comp.winner"
      [runnerUp]="comp.runnerUp"
      [progress]="comp.progress"
      [status]="comp.status"
      [attributes]="comp.attributes"
    />
  }
</div>
